/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.product-recommendations--parent');
  }

  fetchProducts() {
    // Don't fetch if already loaded
    if (this.classList.contains('product-recommendations--loaded')) {
      return;
    }

    console.log('Fetching recommendations from:', this.dataset.url);
    
    fetch(this.dataset.url)
      .then(response => {
        console.log('Response status:', response.status);
        return response.text();
      })
      .then(text => {
        console.log('Response text length:', text.length);
        console.log('Response preview:', text.substring(0, 500));
        
        const html = document.createElement('div');
        html.innerHTML = text;
        
        // Log what we found in the response
        console.log('Response contains product-recommendations:', html.querySelector('product-recommendations') !== null);
        console.log('Response contains product-card-small:', html.querySelector('.product-card-small') !== null);
        console.log('Response contains complementary-products:', html.querySelector('.complementary-products') !== null);
        
        // Look for the product-recommendations element in the response
        const recommendations = html.querySelector('product-recommendations');
        
        if (recommendations) {
          console.log('Recommendations innerHTML length:', recommendations.innerHTML.trim().length);
          console.log('Recommendations content:', recommendations.innerHTML.substring(0, 300));
        }
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          // Replace this element's content with the recommendations content
          this.innerHTML = recommendations.innerHTML;
          
          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');
            
            if (document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          }
          
          // Make sure it's visible
          this.style.display = '';
          console.log('Recommendations loaded and displayed');
        } else {
          // No recommendations found, hide the component
          this.style.display = 'none';
          console.log('No recommendations found, hiding component');
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error('Error loading product recommendations:', e);
        this.style.display = 'none';
        this.classList.add('product-recommendations--loaded');
      });
  }
  
  connectedCallback() {
    // Add a small delay to ensure everything is ready
    setTimeout(() => this.fetchProducts(), 200);
  }
}

customElements.define('product-recommendations', ProductRecommendations);